import React, { useEffect, useRef, useState } from 'react'
import SaveIcon from '@mui/icons-material/Save'
import { Close, Search as SearchIcon } from '@mui/icons-material'
import {
  Box,
  Button,
  Divider,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import { GLOBAL_CONSTANTS } from '../../../constants/globalConstants'
import {
  RETURN_COLUMN,
  RETURN_STEP_TABS,
} from '../../../constants/returnsStep'
import { CommonModal, CommonTable, Search } from '../../common'
import CommonTabs from '../../common/CommonTabs'
import DownloadFiles from './components/DownloadFiles'
import GenerateFVU from './components/GenerateFVU'
import KeyFilter from '../Define/common/KeyFilter'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { useSnackbar } from '../../../contexts/SnackbarProvider.jsx'
import { useReturnsChallan } from '../../../hooks/useRetursChallan.js'
import { useAnnexture } from '../../../hooks/useAnnexture.js'
import { useReturnsForm } from '../../../hooks/useReturnForm.js'
import DownloadIcon from '../../../assets/icons/DownloadIcon.jsx'
import { searchFields } from '../../../constants/returnsStep'
import { useReturnsStep } from '../../../hooks/useReturnStep.js'
import SearchIconBtn from '../../../assets/icons/SearchIconBtn.jsx'
import EditIcon from '../../../assets/icons/EditIcon.jsx'

function ReturnsStep() {
  const { showSnackbar } = useSnackbar()
  const {
    generateFVUDialogOpen,
    setgenerateFVUDialogOpen,
    downloadFilesDialogOpen,
    setDownloadFilesDialogOpen,
    activeTabIndex,
    setActiveTabIndex,
    editMode,
    setEditMode,
    isFormView,
    setIsFormView,
    showtable,
    tableData,
    dowloadFileList,
    defaultSearchCOList,
    currentPage,
    itemsPerPage,
    totalItems,
    loading,
    isDownloadLoading,
    isSaving,
    setIsSaving,
    searchOpen,
    anchorEl,
    searchCriteria,
    tanMasterUuid,
    viewModetanMasterUuid,
    setViewModeTanMasterUuid,
    setDefaultSearchCOList,
    setSearchCriteria,
    fetchReturnsForm,
    fetchDownloadFiles,
    handleGenerateRegularFile,
    handleViewClick,
    handlePageChange,
    handleItemsPerPageChange,
    handleApplySearch,
    handleResetSearch,
    handleBulkDownload,
    handleSearch,
    handleCloseSearch,
    handleRefreshData,
    refreshLoadingRowId,
    formVersion,
    effectiveFormType,
  } = useReturnsStep({ showSnackbar })

  const challanHook = useReturnsChallan({
    viewModetanMasterUuid,
    defaultSearchCOList,
    showSnackbar,
  })

  const annextureHook = useAnnexture({
    viewModetanMasterUuid,
    defaultSearchCOList,
    showSnackbar,
  })

  const formHook = useReturnsForm({
    viewModetanMasterUuid,
    defaultSearchCOList,
    showSnackbar,
  })

  const [viewLoadingRowId, setViewLoadingRowId] = useState(null)
  const skipEffectRef = useRef(false)

  useEffect(() => {
    if (!viewModetanMasterUuid) return
    if (skipEffectRef.current) {
      skipEffectRef.current = false
      return
    }

    if (RETURN_STEP_TABS[activeTabIndex]?.label === 'Form') {
      formHook.fetchForm({
        tanMasterUuid: viewModetanMasterUuid,
        defaultSearchCOList,
        page: 1,
        pageSize: 20,
      })
    }
    if (RETURN_STEP_TABS[activeTabIndex]?.label === 'Challan') {
      challanHook.fetchChallanData({
        tanMasterUuid: viewModetanMasterUuid,
        defaultSearchCOList,
      })
    }
    if (
      RETURN_STEP_TABS[activeTabIndex]?.label ===
      'Annexure I (Deductee Details)'
    ) {
      annextureHook.fetchAnnextureData({ tanMasterUuid: viewModetanMasterUuid, defaultSearchCOList })
    }
  }, [activeTabIndex, viewModetanMasterUuid])

  const handleViewFormMode = async (rowData) => {
    try {
      setViewLoadingRowId(rowData.uuid);
      setDefaultSearchCOList(rowData);
      skipEffectRef.current = true;
      setViewModeTanMasterUuid(rowData.tanUuid);

      const [formRes, challanRes] = await Promise.all([
        formHook.fetchForm({
          tanMasterUuid: rowData?.tanUuid,
          defaultSearchCOList: rowData,
        }),
        challanHook.fetchChallanData({
          tanMasterUuid: rowData?.tanUuid,
          defaultSearchCOList: rowData,
        }),
      ]);

      if (formRes && challanRes) {
        await annextureHook.fetchAnnextureData({
          tanMasterUuid: rowData?.tanUuid,
          defaultSearchCOList: rowData,
        });
      }

      setIsFormView(rowData.uuid);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setViewLoadingRowId(null);
    }
  };


  const renderActions = (value, row) => {
    return (
      row.entityTan && row.entityName && row.tanUuid && (
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Tooltip title="View">
            <span>
            <IconButton
              disabled={viewLoadingRowId === row.uuid}
              onClick={() => {
                handleViewFormMode(row)
              }}
              sx={{
                color: viewLoadingRowId === row.uuid ? 'inherit' : 'var(--forbrand-primary)',
              }}
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Refresh">
            <span>
            <IconButton
              disabled={refreshLoadingRowId === row.uuid}
              onClick={() => handleRefreshData(row)}
              sx={{
                color: refreshLoadingRowId === row.uuid ? 'inherit' : 'var(--forbrand-primary)',
              }}
            >
              <ReplayOutlinedIcon fontSize="small" />
            </IconButton>
            </span>
          </Tooltip>
        </Box>
      )
    )
  }

  const columnsWithActions = [
    ...RETURN_COLUMN,
    {
      id: 'actions',
      label: 'Actions',
      width: '100px',
      align: 'center',
      render: renderActions,
    },
  ]

  const tabsWithProps = RETURN_STEP_TABS.map(tab => {
    switch (tab.label) {
      case 'Form':
        return {
          ...tab,
          props: {
            editMode,
            formHook,
            formVersion,
          },
        }
      case 'Challan':
        return {
          ...tab,
          props: {
            editMode,
            challanHook,
            formVersion,
            financialYear: defaultSearchCOList?.year || defaultSearchCOList?.financialYear || '',
            formType: effectiveFormType || defaultSearchCOList?.form || defaultSearchCOList?.formType || '',
          },
        }
      default:
        return {
          ...tab,
          props: {
            editMode,
            annextureHook,
            formHook,
            formVersion,
          },
        }
    }
  })

  const ActiveTab = tabsWithProps[activeTabIndex].content
  const activeTabProps = tabsWithProps[activeTabIndex].props

  const handleTabChange = newIndex => {
    if (editMode) return showSnackbar('Please save the changes before switching tab', 'info')
    setActiveTabIndex(newIndex)
    challanHook.setCurrentPage(1),
      challanHook.setItemsPerPage(100),
      annextureHook.setCurrentPage(1),
      annextureHook.setItemsPerPage(100),
      setEditMode(false)
  }

  const handleGenerateFVUDialogClose = () => {
    setgenerateFVUDialogOpen(false)
  }

  const handlegenerateFVUDialogOpen = () => {
    setgenerateFVUDialogOpen(true)
  }

  const handleDownloadFilesDialogOpen = async () => {
    fetchDownloadFiles()
  }

  const handleDownloadFilesDialogClose = () => {
    setDownloadFilesDialogOpen(false)
  }

  const handleEdit = () => {
    setEditMode(true)
  }

  const handleCloseEditMode = () => {
    setEditMode(false)
    formHook.resetForm()
    challanHook.clearEdits()
    annextureHook.clearEdits()
  }

  const handleSave = async () => {
    if (isSaving) return

    setIsSaving(true)

    let isSaved = false

    try {
      switch (RETURN_STEP_TABS[activeTabIndex]?.label) {
        case 'Form':
          isSaved = await formHook.saveForm()
          break
        case 'Challan':
          isSaved = await challanHook.saveChallan()
          break
        case 'Annexure I (Deductee Details)':
          isSaved = await annextureHook.saveAnnexture()
          break
        default:
          return
      }

      if (isSaved) {
        setEditMode(false)
      }
    } finally {
      setIsSaving(false)
    }
  }

  const handleViewClickWithData = async data => {
    await handleViewClick(data)
  }

  return (
    <>
      {/* Key Filters */}
      <KeyFilter
        handleViewClick={handleViewClickWithData}
        isFormView={isFormView}
        isYear={true}
        isQuarter={true}
        isMultiTAN={true}
        setIsFormView={setIsFormView}
        isReturnType={true}
        isForm={true}
        btnName="Generate"
        setActiveTabIndex={setActiveTabIndex}
        defaultSearchCOList={defaultSearchCOList}
      />

      {isFormView ? (
        <div>
          {/* Header and Toolbar */}
          <Toolbar sx={{ justifyContent: 'space-between' }} disableGutters>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontSize: '20px',
                color: 'var(--forbrand-secondary)',
                fontWeight: 500,
              }}
            >
              {`Returns -  ${effectiveFormType || formHook?.formData?.formType || ''} (${formHook?.formData?.returnType || ''
                })`}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <>
                <Tooltip title="Download Excel">
                  <IconButton

                    disabled={isDownloadLoading}
                    onClick={handleBulkDownload}
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={editMode ? GLOBAL_CONSTANTS.SAVE : GLOBAL_CONSTANTS.EDIT}
                >
                  <IconButton
                    size="small"
                    sx={{ color: 'var(--forbrand-primary)' }}
                    disabled={isSaving}
                    onClick={editMode ? handleSave : handleEdit}
                  >
                    {editMode ? <SaveIcon fontSize='12px' /> : <EditIcon />}
                  </IconButton>
                </Tooltip>

                {editMode && (
                  <Tooltip title="Cancel">
                    <IconButton
                      sx={{
                        color: 'var(--forbrand-primary)',
                      }}
                      onClick={handleCloseEditMode}
                    >
                      <Close fontSize='12px' />
                    </IconButton>
                  </Tooltip>
                )}
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: 16,
                    margin: '9px 4px 0 2px',
                    color: 'var(--forbrand-color)',
                  }}
                />
              </>
              <Button
                variant="outlined"
                sx={{
                  px: '16px',
                  py: '8px',
                  height: '32px',
                  textTransform: 'none',
                  fontWeight: 500,
                  borderColor: 'var(--border-strong)',
                  color: 'var(--forbrand-primary)',
                  marginTop: '2px',
                }}
                onClick={handleGenerateRegularFile}
              >
                Generate Regular File
              </Button>
              <Button
                variant="outlined"
                sx={{
                  px: '16px',
                  py: '8px',
                  height: '32px',
                  textTransform: 'none',
                  fontWeight: 500,
                  borderColor: 'var(--border-strong)',
                  color: 'var(--forbrand-primary)',
                  marginTop: '2px',
                }}
                onClick={handlegenerateFVUDialogOpen}
              >
                Generate FVU
              </Button>

              <Button
                variant="contained"
                sx={{
                  px: '16px',
                  py: '8px',
                  height: '32px',
                  textTransform: 'none',
                  fontWeight: 500,
                  marginTop: '1px',
                  backgroundColor: 'var(--forbrand-bg-variant)',
                  color: 'var(--forbrand-brand-varient)',
                }}
                onClick={handleDownloadFilesDialogOpen}
              >
                Download Files
              </Button>
            </Box>
          </Toolbar>

          {/* Tab Menu */}
          <CommonTabs
            tabs={tabsWithProps}
            activeIndex={activeTabIndex}
            onTabChange={handleTabChange}
          />

          {/* Active Tab */}
          <ActiveTab {...activeTabProps} />

          {/* Generate FVU Dialog Box */}
          <CommonModal
            open={generateFVUDialogOpen}
            onClose={handleGenerateFVUDialogClose}
            title="Upload CSI File"
            maxWidth="md"
          >
            <GenerateFVU
              showSnackbar={showSnackbar}
              setgenerateFVUDialogOpen={setgenerateFVUDialogOpen}
              defaultSearchCOList={defaultSearchCOList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              tanMasterUuid={viewModetanMasterUuid}
            />
          </CommonModal>

          {/* Download Files Dialog Box */}
          <CommonModal
            open={downloadFilesDialogOpen}
            onClose={handleDownloadFilesDialogClose}
            title="File Names"
            maxWidth="md"
          >
            <DownloadFiles
              dowloadFileList={dowloadFileList}
              defaultSearchCOList={defaultSearchCOList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              tanMasterUuid={viewModetanMasterUuid}
            />
          </CommonModal>
        </div>
      ) : (
        showtable && (
          <Box>
            <Toolbar sx={{ justifyContent: 'space-between' }} disableGutters>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: '20px',
                  color: 'var(--forbrand-secondary)',
                  fontWeight: 500,
                }}
              >
                Status Of Generated Returns
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Tooltip title="Advance Search">
                  <IconButton
                    sx={{
                      color: 'var(--forbrand-primary)',
                    }}
                    onClick={handleSearch}
                  >
                    <SearchIconBtn />
                  </IconButton>
                </Tooltip>
              </Box>
            </Toolbar>
            <CommonTable
              columns={columnsWithActions}
              loading={loading}
              data={tableData}
              showActions={false}
              onItemsPerPageChange={handleItemsPerPageChange}
              onPageChange={handlePageChange}
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              showFooter={true}
              emptyMessage="No data found"
            />
          </Box>
        )
      )}

      <Search
        open={searchOpen}
        onClose={handleCloseSearch}
        onApply={handleApplySearch}
        onReset={handleResetSearch}
        anchorEl={anchorEl}
        fields={searchFields}
        placement="bottom-start"
        setSearchCriteria={setSearchCriteria}
        searchCriteria={searchCriteria}
      />
    </>
  )
}

export default ReturnsStep